module.exports = __webpack_public_path__ + "img/ cornerQRBase.a7bf34a0.png";